import { ALIGN, APP } from "_pixiSrc/globals";

import { ASSETS_PATH } from "../Constants";
import Button from "./Button";
import I18 from "_pixiSrc/I18";
import ScreenLocker from "./ScreenLocker";
import Sprite from "_pixiSrc/display/Sprite";
import Static from "../libraries/Static";
import { Utils } from "_pixiSrc/Utils";

class AdMessage extends Sprite {
    constructor(
        id,
        data = null,
        autoReload = true,
        button1Text = "",
        button1Callback = () => {},
        button2Text = "",
        button2Callback = () => {}
    ) {
        super();

        console.error(id, data);

        this.autoReload = autoReload;

        const message = I18.f(`error_${id}`);
        const languages = [
            "en",
            "de",
            "es",
            "fr",
            "it",
            "nl",
            "pl",
            "ru",
            "tr",
            "cs",
        ];
        const GET = Utils.parseGet();
        let locale = GET.locale ? GET.locale.substr(0, 2) : "";
        if (languages.indexOf(locale) < 0) {
            locale = languages[0];
        }
        this.locale = locale;

        if (!APP.ready) {
            this.showHtml(message);
            return;
        }

        APP.currentWindow.ui.buttons.spin.closeAction();

        this.back = this.addChild(new ScreenLocker(0x270029, 0.9));

        // Static.writeText(this, I18.f('error'), 'font_gold5', 0, -100);
        const messageSprite = Static.writeNativeText(
            this,
            message,
            "lato-regular",
            0,
            0,
            {
                align: ALIGN.CENTER,
                fill: 0xffffff,
                dropShadow: true,
                dropShadowAngle: 0,
                dropShadowBlur: 12,
                dropShadowColor: 0xff2fff,
                dropShadowDistance: 0,
                wordWrap: true,
                wordWrapWidth: 500,
                alignText: "center",
                size: 21,
                stroke: 0x1c011c,
                strokeThickness: 1,
                padding: 12,
            }
        );
        messageSprite.position.set(0, -messageSprite.height);

        const btnAssetName = button1Text;
        const btnHitArea =
            btnAssetName === "error/ok"
                ? new PIXI.RoundedRectangle(-75, -25, 152, 42, 15)
                : new PIXI.RoundedRectangle(-110, -25, 222, 42, 15);


        const btn = this.addChild(
            new Button(btnAssetName, 0, 50, 1, () => {
                button1Callback();
                this.close();
            })
        );
        btn.hitArea = btnHitArea;

        btn.on("pointerdown", () => {
            if (btn.isDisabled) {
                return;
            }
            btn.isPointerDown = true;
            btn.gotoAndStop(2);
        });

        btn.on("pointerover", () => {
            if (btn.isDisabled) {
                return;
            }
            if (btn.isPointerDown) {
                btn.gotoAndStop(2);
            } else {
                btn.gotoAndStop(1);
            }
        });

        const btn2AssetName = button2Text;
        const btn2HitArea =
            btn2AssetName === "error/ok"
                ? new PIXI.RoundedRectangle(-75, -25, 152, 42, 15)
                : new PIXI.RoundedRectangle(-110, -25, 222, 42, 15);


        const btn2 = this.addChild(
            new Button(btn2AssetName, 0, 100, 1, () => {
                button2Callback();
                this.close();
            })
        );
        btn2.hitArea = btn2HitArea;

        btn2.on("pointerdown", () => {
            if (btn2.isDisabled) {
                return;
            }
            btn2.isPointerDown = true;
            btn2.gotoAndStop(2);
        });

        btn2.on("pointerover", () => {
            if (btn2.isDisabled) {
                return;
            }
            if (btn2.isPointerDown) {
                btn2.gotoAndStop(2);
            } else {
                btn2.gotoAndStop(1);
            }
        });

        const myJackpotLogo = this.addChild(
            APP.library.getSprite("main/my-jackpot-logo")
        );
        myJackpotLogo.position.set(0, 200);
        myJackpotLogo.scale.set(0.8);
    }

    showHtml(message) {
        const container =
            document.getElementsByClassName("p2m-layer-screens")[0];

        if (container) {
            container.style.display = "block";
            container.style.background = `url(${ASSETS_PATH.IMAGES}/1.5/error/error-background.png)`;
            container.style.backgroundSize = "cover";
            container.style.backgroundPosition = "50%";
            APP.resizeDecor();

            const canvas = container.getElementsByTagName("canvas")[0];
            if (canvas) {
                canvas.style.visibility = "hidden";
            }

            this.htmlWindow = document.createElement("div");
            this.htmlWindow.classList.add("error-window");

            let d = document.createElement("div");
            d.classList.add("error-message");
            d.innerHTML = message;
            this.htmlWindow.appendChild(d);
            this.htmlWindow._message = d;

            d = document.createElement("div");
            d.style.background = `url(${
                ASSETS_PATH.IMAGES
            }/1.5/error/${this.locale.toUpperCase()}/btn-reload.png)`;
            d.style.margin = "auto";
            d.style.overflow = "hidden";
            const actionArea = document.createElement("div");
            actionArea.style.cursor = "pointer";
            d.appendChild(actionArea);
            this.htmlWindow.appendChild(d);
            this.htmlWindow._button = d;
            this.htmlWindow._buttonArea = actionArea;

            this.myJackpotLogo = container.appendChild(
                document.createElement("div")
            );
            this.myJackpotLogo.style.background = `url(${ASSETS_PATH.IMAGES}/1.5/main/my-jackpot-logo.png)`;
            this.myJackpotLogo.classList.add("my-jackpot-logo");

            actionArea.addEventListener("click", this.close.bind(this), false);
            actionArea.addEventListener(
                "touchstart",
                this.close.bind(this),
                false
            );

            document.body.appendChild(this.htmlWindow);
        }

        this.resizeHtml();

        APP.layout.on("fitlayout", this.resizeHtml, this);
    }

    resizeHtml() {
        const container =
            document.getElementsByClassName("p2m-layer-screens")[0];
        if (container) {
            const canvas = container.getElementsByTagName("canvas")[0];
            if (canvas) {
                const scale = APP.layout.calculatedSize.scale;

                let w = Math.floor(500 * scale);
                let h = Math.floor(379 * scale);
                const myJackpotLogoWidth = 350 * scale;
                const myJackpotLogoHeight = 201 * scale;

                this.htmlWindow.style.width = `${w}px`;
                this.htmlWindow.style.height = `${h}px`;
                this.htmlWindow.style.marginLeft = `${-w / 2}px`;
                this.htmlWindow.style.backgroundSize = `${w}px ${h}px`;

                this.htmlWindow._message.style.fontSize = `${24 * scale}px`;
                this.htmlWindow._message.style.marginBottom = `${35 * scale}px`;

                w = Math.floor(245 * scale);
                h = Math.floor(65 * scale);
                this.htmlWindow._buttonArea.style.width = `${Math.floor(
                    220 * scale
                )}px`;
                this.htmlWindow._buttonArea.style.height = `${Math.floor(
                    40 * scale
                )}px`;
                this.htmlWindow._buttonArea.style.marginLeft = `${
                    13 * scale
                }px`;
                this.htmlWindow._buttonArea.style.marginTop = `${9 * scale}px`;

                this.htmlWindow._button.style.fontSize = `${20 * scale}px`;
                this.htmlWindow._button.style.width = `${w}px`;
                this.htmlWindow._button.style.height = `${h}px`;
                this.htmlWindow._button.style.lineHeight = `${h}px`;
                this.htmlWindow._button.style.backgroundSize = `${
                    w * 4
                }px ${h}px`;

                this.myJackpotLogo.style.width = `${myJackpotLogoWidth}px`;
                this.myJackpotLogo.style.marginLeft = `${
                    -myJackpotLogoWidth / 2
                }px`;
                this.myJackpotLogo.style.height = `${myJackpotLogoHeight}px`;
                this.myJackpotLogo.style.marginTop = `${
                    -myJackpotLogoHeight / 2 - 12 * scale
                }px`;
                this.myJackpotLogo.style.padding = `${scale * 2}px`;
            }
        }
    }

    close() {
        this.safeRemove();

        APP.glovalErrorView = null;

        if (this.autoReload) {
            window.location.reload();
        }
    }
}

export default AdMessage;
